const priceContracts: {cakeAddress: string, wbchAddress: string, lpAddress:string} = {
  cakeAddress: '0x77CB87b57F54667978Eb1B199b28a0db8C8E1c0B',
  wbchAddress: '0x3743eC0673453E5009310C727Ba4eaF7b3a1cc04',
  lpAddress: '0x0D4372aCc0503Fbcc7EB129e0De3283c348B82c3'
}

export default priceContracts